<template>
    <!-- 派对订单取消 -->
    <div>
        <a-modal
        centered
        :visible="visible"
        :confirmLoading="confirmLoading"
        @ok="confirm"
        @cancel="close"
        >
            <div class="mb24 ml16">是否确认取消订单？</div>
            <a-form :form="form" layout="inline">
                <a-form-item label="备注" >
                    <a-input style="width:400px; resize: none;" placeholder="请输入备注，10-50字" type="textarea" v-decorator="['remark',{rules: [{required: true, min: 10,max: 50, message: '请输入备注，10-50字'}]}]" />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
    export default {
        name: "partyOrderCancel",
        zh: "派对订单取消",
        components: {
        },
        props: {
        },
        data() {
            return {
                visible: false,
                orderId: null,
                confirmLoading: false
            }
        },
        computed: {},
        watch: {
            visible(val) {

            }
        },
        methods: {
            open(orderId) {
                this.visible = true;
                this.orderId = orderId;
            },
            confirm() {
                if (this.confirmLoading) {
                    return false;
                }
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    }
                    this.confirmLoading = true;
                    this.$api.order.partyOrderRefundCancel({
                        body: {
                            id: this.orderId,
                            remark: values.remark
                        }
                    }).then(res => {
                        this.$message.success('操作成功！');
                        this.confirmLoading = false;
                        this.close();
                    }).catch(err => {
                        this.confirmLoading = false;
                    });
                });
                
            },
            close() {
                this.visible = false;
                this.$emit('cancel');
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        updated() {},
        mounted() {},
    };
</script>

<style lang="scss">
</style>
